import React, { useEffect, useState, useRef, useContext } from "react";
import queryString from "query-string";
import SubHeader from "../../../../components/WithSubHeaderBG";
import GenericError from "../../../../components/GenericError";
import PrivatePage, { menuItemObj } from "../../../../components/PrivatePage";
import EditorArt from "../../../../components/Images/EditorArt";
import CreatorInfo from "../../../../components/CreatorInfo";
import { useCreatorProfile } from "../../../../lib/customHooks";
import { checkOverseasUser, handlePageLoadEventLog } from "../../../../lib/utils";
import { usePaginationNavigator } from "../../../../lib/customHooks";
import {
  StepsContractDiv
} from "../styles";
import { get } from "../../../../lib/api";
import Loader from "../../../../components/Loader";
import { useInfiniteScroll } from "../../../../lib/customHooks";
import AlertSnackBar from "../../../../components/AlertSnackBar";
import DisabledNovelPopup from "./disabledNovelPopup";
import Step from "../../../Home/WBPSteps/step1";
import Terms from "../../../Home/termsAndConditions";
import { AccountContext } from "../../../../providers/accountProvider";
import BookDetail from "./Sections/BookDetail";
import ShareBookModule from "./Sections/ShareBookModule";
import ChaptersModule from "./Sections/ChaptersModule";
import BookNotification from "./Sections/BookNotification";
import ContractModule from "./Sections/ContractModule";
import BookModuleDiscovery from "./Sections/ModuleDiscovery";

function NovelDetail(props) {
  const [bookDetails, setBookDetails] = useState({});
  const [chapters, setChapters] = useState({});
  const [haveBookDetails, setHaveBookDetails] = useState(false);
  const [showLoader, setShowLoader] = useState(true);
  const [applyContract, setApplyContract] = useState(false)
  const [showTNC, setShowTNC] = useState(false)
  const [nextUrl, setNextUrl] = useState(null);
  const isFetching = useInfiniteScroll(fetchMoreData);
  const { user } = useContext(AccountContext)
  const [apiError, toggleApiError] = useState(false); 
  const [chapterLoader, setChapterLoader] = useState(false);
  const [isBookOptionsShown, toggleShowBookOptions] = useState(false);
  const [isUrlCopyToClipboard, setIsUrlCopyToClipboard] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false)
  const bookOptionsRef = useRef();
  const isBookPublished = (bookDetails.status === "approved" || bookDetails.status === "published")
  const conditionToShowShareModuleForUS = isBookPublished && bookDetails?.is_series_live
  const {
    isDrawerShowing,
    setDrawerShowing,
    onUserClick,
    userInfo,
  } = useCreatorProfile();

  const {
    setCurrentPaginationNo,
  } = usePaginationNavigator();
  
  const [prevUrl, setPrevUrl] = useState(null);
  const params = queryString.parse(props.location.search);
  const id = props.match.params.id;
  const active = params.tab || "published";

  useEffect(() => {
    handlePageLoadEventLog(`novel_detail_${active}`)
  }, [active]);

  useEffect(() => {
    fetchNovelDetail();
  }, [])

  const fetchNovelDetail=()=>{
      get("/content_api/book.novel_details", {
        params: {
          book_id: id,
          req_author: 1,
          view: "dashboard",
          is_novel: 1,
        },
      })
        .then((res) => {
          setHaveBookDetails(true);
          setBookDetails(res.results);
          window.localStorage.setItem('NovelImage',res.results.image_url);
          const isNovelDisabled = Boolean(res.results.is_disabled)
          setIsDisabled(isNovelDisabled)
          // if(isNovelDisabled) getChaptersByStatus(isNovelDisabled);
          // !checkOverseasUser(user) && fetchContractDetail(res.results.author_info.fullname,res.results)
          setShowLoader(false);
        })
        .catch((err) => {
          setShowLoader(false);
          throw err;
        });
  }

  const handleClick = (e) => {
    if (bookOptionsRef.current && !bookOptionsRef.current.contains(e.target)) {
      toggleShowBookOptions(false);
    }
  };

  useEffect(() => {
    window.addEventListener("click", handleClick);
    return () => window.removeEventListener("click", handleClick);
  }, []);

    

  function fetchMoreData(setIsFetching) {
    if (!nextUrl || applyContract) {
      setIsFetching(false);
      return;
    }
    get(nextUrl)
      .then((response) => {
        setChapters((prevState) => ({
          chapters: prevState.chapters.concat(response.results.chapters),
        }));
        setNextUrl(response.results.next_url);
        setIsFetching(false);
        const nextNumber = response.results.next_url
          ? Number(
              response.results.next_url
                .split("page_no")[1]
                .split("&")[0]
                .slice(1)
            ) - 1
          : Math.ceil(response.results.chapter_count / 10);
        setCurrentPaginationNo(nextNumber);
      })
      .catch((error) => {
        setIsFetching(false);
        throw error;
      });
  }

  const handleApiError = () => {
    toggleApiError(false);
    props.history.push(`${menuItemObj.novels}?tab=published`);
  };
  
  if(showTNC){
    return <Terms dismissTerms={() => setShowTNC(false)}/>
  }
  if(applyContract){
    return (
      <StepsContractDiv>
        <Step isNovelContract id={bookDetails.book_id} book_name={bookDetails.book_title} book_language={bookDetails.language} showTerms={() => setShowTNC(true)} handleContractDetails={(authorName) => {
          fetchNovelDetail()
          setApplyContract(false)
        }}/>
      </StepsContractDiv>
    )
  }

  return (
    <>
      <CreatorInfo
        show={isDrawerShowing}
        userInfo={userInfo}
        close={() => setDrawerShowing(false)}
      />
      <GenericError show={apiError} onClose={() => handleApiError()} />
      {showLoader && <Loader />}
      {/* {!showLoader && <BookNotification id={id}/>} */}
      {!showLoader && !apiError && (
        <SubHeader title="Novel Detail" showBackButton>
          {bookDetails.book_id && (
            <BookDetail book={bookDetails} onUserClick={onUserClick}/>
          )}
          {(bookDetails?.is_novel === 2 ? conditionToShowShareModuleForUS : isBookPublished) && 
            <ShareBookModule 
              bookTitle={bookDetails.book_title} 
              setIsUrlCopyToClipboard={setIsUrlCopyToClipboard} 
              bookId={bookDetails.book_id}
              bookDetails={bookDetails}
            />}
          <BookModuleDiscovery user={user} bookDetails={bookDetails} />
          {!checkOverseasUser(user) && <ContractModule bookDetails={bookDetails} setApplyContract={setApplyContract}/>}
          {haveBookDetails && (
            <ChaptersModule 
              bookDetails={bookDetails} 
              params={params} 
              setNextUrl={setNextUrl} 
              prevUrl={prevUrl}
              chapters={chapters}
              setChapters={setChapters}
              fetchNovelDetail={fetchNovelDetail}
              isFetching={isFetching}
              setPrevUrl={setPrevUrl}
              chapterLoader={chapterLoader}
              setChapterLoader={setChapterLoader}
              {...props}
            />
          )}
          {isDisabled && <DisabledNovelPopup bookId={bookDetails.book_id} />}
        </SubHeader>
      )}
      {isUrlCopyToClipboard && <AlertSnackBar text="Copied To Clipboard" close={() => setIsUrlCopyToClipboard(false)} />}
    </>
  );
}

export default function WrappedNovelDetail() {
  return (
    <PrivatePage>
      <NovelDetail />
    </PrivatePage>
  );
}